<template>
  <v-select ref="selectElement" solo flat :items="items" height="28" persistent hide-details dense :menu-props="menuProps" :attach="computedAttach" v-model="selected"
            :placeholder="placeholder" :filled="filled" :readonly="readonly" :loading="loading" :return-object="returnObject"></v-select>
</template>

<script>
  export default {
    name: 'ResSelect',
    data() {
      return {
        defaultAttach: ''
      }
    },
    props: {
      value: {
        required: true
      },
      items: {
        type: Array
      },
      attach: {
        default: null
      },
      placeholder: {
        type: String,
        default: ''
      },
      menuProps: {
        type: Object,
        default: () => {return { bottom: true } }
      },
      filled: {},
      readonly: {},
      loading: {
        type: Boolean,
        default: false
      },
      returnObject: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      selected: {
        get () {
          return this.value
        },
        set(newValue) {
          this.$emit("input", newValue)
        }
      },
      computedAttach() {
        return this.attach || this.defaultAttach
      }
    },
    methods: {
      selectItem(item) {
        setTimeout(() => {
          if (this.$refs.selectElement) {
            this.$refs.selectElement.selectedItems = [JSON.parse(JSON.stringify(item))];
          }
        }, 1000)
      }
    },
    mounted() {
      this.defaultAttach = this.$refs.selectElement.$el;
    }
  }
</script>

<style scoped lang="scss">
  div.v-input.v-input--hide-details.v-input--dense {
      border-radius: 6px;
      border: solid 1px var(--v-resGrey-darken1);
  }
  div.v-input.v-input--hide-details.v-input--dense::v-deep {
    .v-menu__content.theme--light.menuable__content__active {
      margin-top: 30px !important;
    }
    .v-input__slot {
      padding-right: 0px !important;
      min-height: 28px !important;
    }
    .v-input__append-inner {
      padding: 7px 8px;
      background-color: var(--v-resBlue-darken1);
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px
    }
    .v-input__icon {
      width: 16px;
      height: 16px;
      min-width: 16px;
    }
    .v-input__icon .v-icon {
      color: white !important;
    }
  .v-input__control {
    min-height: 28px !important;
  }
  }
</style>
